import React from 'react';
import { CreatorHero } from '../components/creator/CreatorHero';
import { CreatorEarnings } from '../components/creator/CreatorEarnings';
import { CreatorHowItWorks } from '../components/creator/CreatorHowItWorks';
import { CreatorCreditsOrCash } from '../components/creator/CreatorCreditsOrCash';
import { CreatorIdeas } from '../components/creator/CreatorIdeas';
import { CreatorDisclose } from '../components/creator/CreatorDisclose';
import { CreatorRules } from '../components/creator/CreatorRules';
import { CreatorFAQ } from '../components/creator/CreatorFAQ';
export function CreatorProgram() {
  return <div className="pt-24 pb-16 bg-[#FAF8F4]" data-id="element-6667" data-mp="1x1jx6ftq5bzx">
      <CreatorHero data-id="element-6668" data-mp="1x3ed1fq52dx5" />
      <CreatorEarnings data-id="element-6669" data-mp="1sav2ysqnu0x3" />
      <CreatorHowItWorks data-id="element-6670" data-mp="1sabhj21swueb" />
      <CreatorCreditsOrCash data-id="element-6671" data-mp="1s90i1efe28t0" />
      <CreatorIdeas data-id="element-6672" data-mp="1s8qmzcfhlbgg" />
      <CreatorDisclose data-id="element-6673" data-mp="14kqwmdm37n2e" />
      <CreatorRules data-id="element-6674" data-mp="14jz4jcrp87gv" />
      <CreatorFAQ data-id="element-6675" data-mp="14jfwqovrizgk" />
    </div>;
}